<template>
  <div id="popup_event" name="notice" class="notice-modal">
    <modal
      v-if="!isCloseModal"
      :btn-count="2"
      label-left="오늘 더 이상 보지않기"
      label-right="닫기"
      @click-right="closeNoticeModal"
      @click-left="saveModalInCookie"
    >
      <template v-slot:modal-body>
        <router-link to="/news/detail?id=dc1d52c3-73b0-4c7b-9e05-0255bf57ffdd">
          <img
            class="img"
            src="@/assets/source/images/newgame_2511/table_popup.png"
            alt="팝업"
          />
          <div class="go-to-link">
            <span>자세히 보기 > </span>
          </div>
        </router-link>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/modal/modal.vue";
import Cookie from "@/utils/cookies.js";
import dayjs from "dayjs";

export default {
  components: {
    Modal,
  },

  data() {
    return {
      isCloseModal: false,
    };
  },
  methods: {
    closeNoticeModal() {
      this.isCloseModal = true;
    },

    saveModalInCookie() {
      let date = dayjs(new Date());
      let endDate = date.endOf("day").format();
      Cookie.setCookie("event_notice", "done", endDate);
      this.isCloseModal = true;
    },
  },
};
</script>

<style scoped>
.img {
  display: block;
}

.notice-modal ::v-deep .modal-container {
  position: relative;
  margin: 0px auto;
  padding: 0;
  width: 300px;
  background-color: transparent;
  border-radius: 2px;
  box-shadow: none;
  transition: all 0.3s ease;
}
.notice-modal ::v-deep .modal-container img {
  width: 100%;
}
.go-to-link {
  width: 100%;
  height: 40px;
  background-color: #ff5230;
  display: flex;
  justify-content: center;
  align-items: center;
}

a {
  text-decoration: none;
}

.go-to-link span {
  color: #fff;
  font-size: 14px;
}
.notice-modal::v-deep .modal-mask {
  top: 142px;
  left: 320px; /* 첫 번째 팝업 옆에 위치 */
}
.notice-modal::v-deep .left {
  background: #000;
  border-right: 1px solid #fff;
}

.notice-modal::v-deep .right {
  background: #000;
}

.notice-modal::v-deep .modal-mask {
  position: absolute;
  width: 0;
  height: 0;
}
.notice-modal::v-deep .footer-button {
  height: 40px;
}
</style>
